module.exports = __webpack_public_path__ + "img/img_article6_radio@3x.a6038bd4.png";